import React from 'react';
import SelectForm from './SelectForm';

export type SelectFormOption = { label: React.ReactNode; value: any };

export type SelectFormAdapterProps = {
  name: string;
  control: any;
  label?: React.ReactNode;
  options: SelectFormOption[];
  defaultValue?: any;
  // Optional extras (kept optional to avoid strict prop requirements in TSX files)
  isClearable?: boolean;
  errors?: any;
  placeholder?: string;
  readOnly?: boolean;
  onChange?: (value: any) => void;
  menuPosition?: any;
  loadOptions?: any;
  getOptionLabel?: any;
  defaultOptions?: any;
  isMulti?: boolean;
  customOption?: any;
  noIndicator?: boolean;
  rules?: any;
  autofocus?: boolean;
  labelKey?: string;
  valueKey?: string;
  cloneOptionType?: string;
  menuPortalTarget?: HTMLElement;
  [key: string]: any;
};

// Force-untyped component to avoid TS inferring strict prop requirements from JS
const UntypedSelectForm: React.ComponentType<any> = SelectForm as unknown as React.ComponentType<any>;

export default function SelectFormAdapter(props: SelectFormAdapterProps) {
  return <UntypedSelectForm {...(props as any)} />;
}
